<template>
  <Modal
    :id="'cmp-licence-licence-advanced_search'"
    :loading="loading"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $dft.snakeCaseToWords("advanced_search")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'search'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="search"
            isModel
            :placeholder="$t('search')"
            @valuechanged="onTextFieldValueChange"
          />
      
          <Dropdown
            :id="'status'"
            class="m2"
            :options="advancedSearchData.taskStatusTV || []"
            :selected="
              advancedSearchData.taskStatusTV.find((t) => t.value == status)
            "
            :placeholder="$t('status')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('status', e)"
            :listHeight="250"
          />
          <Dropdown
            :id="'sent_user'"
            class="m2"
            :options="advancedSearchData.sentUsersTV"
            :selected="
              advancedSearchData.sentUsersTV.find(
                (x) => x.value == sent_user
              )
            "
            :placeholder="$t('sent_user')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('sent_user', e)"
          />
          <Dropdown
            :id="'assigned_users'"
            class="m2"
            :options="advancedSearchData.sentUsersTV"
            :selected="
              advancedSearchData.sentUsersTV.filter((e) =>
                ((assigned_users && assigned_users.split(',')) || []).includes(e.value)
              )
            "
            :placeholder="$t('assigned_user')"
            multiple
            allnone
            box
            @selectedChange="(e) => onDropdownChangeMulti(e)"
            :listHeight="350"
          />

          <TextField
            type="date"
            :id="'start'"
            class="m1"
            :placeholder="`${$t('start')}`"
            :value="start"
            :showImmediate="true"
            autocomplete="off"
            @valuechanged="onDateChange"
          />
          <TextField
            type="date"
            :id="'end'"
            class="m1"
            :placeholder="`${$t('end')}`"
            :value="end"
            :showImmediate="true"
            autocomplete="off"
            @valuechanged="onDateChange"
          />

        </div>
      </div>
    </template>

    <template slot="options">

      <button class="dt-button s6" @click.stop="onCancel">Close</button>
      <button
        class="dt-button v1 s6"
        @click.stop="onSearch"
        :disabled="this.isFilterEmpty()"
        :class="{
          disabled: this.isFilterEmpty(),
        }"
        :title="this.isFilterEmpty() ? filterEmptyError() : ''"
      >
        Search
      </button>
    </template>
  </Modal>
</template>

<script>
import FileDownload from "js-file-download";
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";

import { async } from "rxjs/internal/scheduler/async";

import { createTV } from "../../../../models/text-value.model";
import { addRemoveSet, subscribeSubject } from "../../../../utility";
import {
  ensureBoolIntObjectFromKeys,
  ensureStringObject,
  ensureStringObjectFromKeys,
  keyValuesToObj,
} from "../../../../utility/fp";
import { Subject } from "rxjs";
import { createAdvancedSearchModal } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
export const taskListAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "status",
    "sent_user",
    "search",
    "start",
    "end",
    "assigned_users"
  ],
  searchConfigIntKeys: [
    // "composer_missing",
    // "writer_missing",
    // "publisher_missing",
    // "producer_missing",
    // "arranger_missing",
  ],

  //no checkbox but return 0 or 1
  booleanSearchKeyLabelMap: {
    // isrc_error: "ISRC Error",
    // missing_main_product: "Missing Main Product",
    // product_track_mismatch: "Product Track Mismatch",
    // no_contract: "No Contract",
    // playtime_missing: "Playtime is missing",
  },

  //Dropdown Values
  searchConfigTVMap: [
    ["status", "taskStatusTV"],
    ["sent_user", "sentUsersTV"],
    ["assigned_users","sentUsersTV"]
    
  
   // ["last_stmt", "lastStmtTV"],
  
  ],
  searchConfigMulTVMap: [
    //["assigned_users", "genresTV"]
    
    
  ],
  searchConfigOmitKeyMap: [
    // ["composer", "composer_missing"],
    // ["writer", "writer_missing"],
    // ["publisher", "publisher_missing"],
    // ["producer", "producer_missing"],
    // ["arranger", "arranger_missing"],
  ],
});

export default {
  components: {
    Modal,
    TextField,
    DTCheckbox,
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },
      status: "",
      sent_user:"",
      search:'',
      start:'',
      end:'',
      assigned_users:"",

      loading: false,
    };
  },
  mixins: [createAdvancedSearchModal(taskListAdvancedSearchConfig)],
  computed: {
    searchFilter: function () {
      return {
        ...ensureStringObjectFromKeys(
          this,
          taskListAdvancedSearchConfig.searchConfigStringKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          taskListAdvancedSearchConfig.booleanSearchKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          taskListAdvancedSearchConfig.searchConfigIntKeys
        ),
        // ...ensureBoolIntObjectFromKeys(
        //   this,
        //   licenceAccountListAdvancedSearchConfig.booleanSearchKeys
        // ),
        // ...ensureBoolIntObjectFromKeys(
        //   this,
        //   licenceAccountListAdvancedSearchConfig.searchConfigIntKeys
        // ),
      };
    },
  },
  methods: {
    onDateChange: function (name, value) {
      this[name] = value;
    },
    onTextFieldValueChange: function (name, value) {
      this[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
    },

    onCheckboxChange: function (name, event) {
      this[name] = event.target.checked;
    },
    onDropdownChangeMulti: function (value) {
      this.assigned_users = value?.map((e) => e.value).join(",");
    },
    onSearch: async function () {
      if (this.isFilterEmpty()) {
        return;
      }
      // console.log({ "this.searchFilter": this.searchFilter });
      this.$emit("search", this.searchFilter);
    },

    onSearchOmittedToggle: function (name) {
      if (this[`${name}_missing`] == 1) {
        this[`${name}_missing`] = "0";
      } else {
        this[`${name}_missing`] = `1`;
      }
    },
    isOmitted(name) {
      return this[`${name}_missing`] == `1`;
    },
    filterEmptyError() {
      return `Please provide value to any one of these Fields - Artist, Title, Version, Track type, Digital right, Genres, Isrc error, Missing main product, Product track mismatch, Licence account, Main label, Any label, Royalty account, No contract, Playtime missing, Composer missing, Composer, Writer missing, Writer, Publisher missing, Publisher, Producer missing, Producer, Arranger missing, Arranger, Metadata value1, Metadata value2, Metadata value3, Track grid`;
    },
    isFilterEmpty() {
      let { status,sent_user,search,start,end,assigned_users} = this;
      if (
        !status &&
        !sent_user  && 
        !search &&
        !start &&
        !end &&
        !assigned_users?.length
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-licence-licence-advanced_search {
  .body-container {
    max-height: 470px;
    padding-right: 15px;
    overflow: hidden;
    overflow-y: auto;

    .dropdown,
    .dt-input-box--container,
    .date-control {
      max-width: 358px;
    }
  }
  .omit-toggler {
    display: flex;
    cursor: pointer;

    &.missed {
      color: var(--c-error);
    }

    .omit-toggler--label {
      margin: auto 0px auto 4px;
      cursor: pointer;
    }
  }

  .search--input {
    flex: 1;
  }

  .search--checkbox {
    min-width: 20px;
    margin-left: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 320px) and (max-width: 480px) {
      padding-left: 0px;
      margin-left: 0px;

      .checkmark {
        margin-left: 10px;
      }
    }
  }

  .checkbox-container {
    .dt-checkbox-control {
      align-items: center;
      .dt-checkbox-label {
        flex: 1;
        padding-left: 10px;
      }
    }
  }

  .row-control {
    margin: 10px 0;
    .search--input {
      max-width: 100%;
    }
  }
  .date-control {
    .dt-input-box--container {
      flex: 1;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
}
</style>